import React from 'react';
import s from './InterSectionBorder.scss';

function InterSectionBorder({ marginTop = '', className = '' }) {
  //const { data } = props;
  return (
    <span
      className={`${s.doubleboder} ${className ? s[className] : ''}`}
      {...marginTop && { style: { marginTop } }}
    />
  );
}

export default InterSectionBorder;
